import React, { useState } from 'react';
import { Package, LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useAuth } from '../context/AuthContext';
import { getTranslation } from '../i18n/translations';
import { toast } from '../hooks/use-toast';

const Login = () => {
  const { login, whiteLabel, language, users } = useAuth();
  const [selectedEmail, setSelectedEmail] = useState('');
  
  const primaryColor = whiteLabel ? '#2D4A8F' : '#F26724';
  const brandName = whiteLabel ? 'Smart Locker System' : 'Swedbank Lockers';
  
  const t = (key, replacements) => getTranslation(key, language, replacements);

  const handleLogin = (email) => {
    const success = login(email);
    
    if (success) {
      toast({
        title: t('login'),
        description: `${t('welcomeTo')} ${brandName}`,
      });
    } else {
      toast({
        title: t('login'),
        description: t('invalidCredentials'),
        variant: 'destructive'
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F6F8] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Package size={48} style={{ color: primaryColor }} />
          </div>
          <h1 className="text-3xl font-bold text-[#1A1A1A] mb-2">{brandName}</h1>
          <p className="text-gray-600">{t('smartSecure')}</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-center text-2xl">{t('login')}</CardTitle>
            <CardDescription className="text-center">
              {t('selectAccount')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {users.map(user => (
                <button
                  key={user.email}
                  onClick={() => handleLogin(user.email)}
                  className="w-full p-4 rounded-lg border-2 transition-all hover:shadow-lg hover:scale-105 focus:outline-none focus:ring-2 text-left"
                  style={{ 
                    borderColor: primaryColor,
                    '--tw-ring-color': primaryColor 
                  }}
                >
                  <div className="flex items-center space-x-3">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl"
                      style={{ backgroundColor: primaryColor }}
                    >
                      {user.name.charAt(0)}
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-[#1A1A1A]">{user.name}</p>
                      <p className="text-sm text-gray-600">{user.department}</p>
                      <p className="text-xs text-gray-500">{user.email}</p>
                    </div>
                    <LogIn size={20} style={{ color: primaryColor }} />
                  </div>
                </button>
              ))}
            </div>
            
            <div className="mt-6 p-4 rounded-lg bg-blue-50 border border-blue-200">
              <p className="text-sm text-blue-800 font-medium mb-2">{t('demoMode')}:</p>
              <div className="text-xs text-blue-700">
                <p>{t('clickAnyUser')}</p>
                <p className="mt-2">• Eric Brisset - Sales</p>
                <p>• Didzis Tupureins - Business Development</p>
                <p>• Alena Ruplane - Administration</p>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <p className="text-center text-sm text-gray-500 mt-4">
          {t('demoOnly')}
        </p>
      </div>
    </div>
  );
};

export default Login;
